import { useState, useMemo } from 'react';
import API from '../../../API';
import { useAuth } from '../../../utils/Auth';
import styles from './SonarSwitch.module.css';

export default function SonarSwitch() {
    // ----- STATE INITIALIZATION -----
    const { updateSonar } = API;
    const { userObj, qr_data } = useAuth();

    const isActive = useMemo(() => (qr_data?.data?.sonar && (qr_data?.data?.sonar - Date.now()) > 0), [qr_data?.data?.sonar]);
    const [ disabled, setDisabled ] = useState(false);
    // ----- END STATE INITIALIZATION -----

    // ----- HANDLE UPDATE -----
    // Updates Sonar time update
    const handleUpdateQR = async () => {
        setDisabled(true);

        const date = Date.now();
        const sonarLength = userObj?.sonar_length || 900000;

        const timeDif = isActive ? date : date + sonarLength;

        try {
            await updateSonar(qr_data?.id, { time: timeDif });
        } catch (err) {
            console.error("Failed to update sonar mode:", err);
        } finally {
            setDisabled(false);
        }
    };
    // ----- HANDLE UPDATE -----

    return (
        <label className={styles.sonarBtn}>
            <input type='checkbox' className={styles.checkbox} id='sonar-check' onChange={handleUpdateQR} defaultChecked={isActive} disabled={disabled} />
            <i className='fa-light fa-radar' />
            Sonar Mode
        </label>
    );
};